import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const CategoryGetList = createAsyncThunk(
  "CategoryGetList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.CATEGORY.GET_USER_CATEGORY_LIST,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);
export const CategoryGetListDetail = createAsyncThunk(
  "CategoryGetListDetail",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.CATEGORYGETLIST,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  CategoryGetList: {
    data: null,
    error: null,
  },
  CategoryGetListDetailData: {
    data: null,
    error: null,
  },
};

const CategorySlice = createSlice({
  name: "CATEGORY",
  initialState,
  reducers: {
    // setLoader: (state, action) => {
    //   state.isLoading = action.payload;
    // },
    //   setWorkFlowGetListData: (state) => {
    //     state.WorkFlowGetListData.data = null;
    //   },
    //   setGetWorkFlowByID: (state) => {
    //     state.GetWorkFlowByIDData.data = null;
    //   },
  },

  extraReducers: (builder) => {
    builder
      .addCase(CategoryGetList.fulfilled, (state, action) => {
        state.CategoryGetList.data = action.payload;
      })
      .addCase(CategoryGetList.rejected, (state, action) => {
        state.CategoryGetList.error = action.error.message;
      })
      .addCase(CategoryGetListDetail.fulfilled, (state, action) => {
        state.CategoryGetListDetailData.data = action.payload;
      })
      .addCase(CategoryGetListDetail.rejected, (state, action) => {
        state.CategoryGetListDetailData.error = action.error.message;
      });
  },
});

// export const { setLoader } = CategorySlice.actions;
export default CategorySlice.reducer;
